import React from "react"
import './DatesBlock.scss'
import { Container, Nav } from "react-bootstrap";

function DatesBlock({ activeTab }) {

    return (
        <div className="dates-block">
            <Container>
                <h3>{"Сроки \nпроведения"}</h3>
            </Container>
            <div className="tab-pills-container">
                <Nav variant="pills" className="">
                    <Nav.Item>
                        <Nav.Link eventKey="dates01">
                            <div className={activeTab === 'dates01' ? "dates-nav-link-item dates-nav-link-item-active" : "dates-nav-link-item"}>
                                <div className={activeTab === 'dates01' ? "number number-active" : "number"}>
                                    <div>01</div>
                                    <div>этап</div>
                                </div>
                                <div className="title">
                                    Регистрация
                                </div>
                                <div className={activeTab === 'dates01' ? "period period-active" : "period"}>
                                    с 15 сентября по 14 октября
                                </div>
                                <div className={activeTab === 'dates01' ? "arrow arrow-active" : "arrow arrow-unactive"}></div>
                                <div className={activeTab === 'dates01' ? "tab-image tab-image-01-active" : "tab-image tab-image-01-unactive"}></div>
                            </div>
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="">
                        <Nav.Link eventKey="dates02">
                            <div className={activeTab === 'dates02' ? "dates-nav-link-item dates-nav-link-item-central dates-nav-link-item-active" : "dates-nav-link-item dates-nav-link-item-central"}>
                                <div className={activeTab === 'dates02' ? "number number-active" : "number"}>
                                    <div>02</div>
                                    <div>этап</div>
                                </div>
                                <div className="title">
                                    {"Отборочный \nэтап"}
                                </div>
                                <div className={activeTab === 'dates02' ? "period period-active" : "period"}>
                                    с 15 сентября по 14 октября
                                </div>
                                <div className={activeTab === 'dates02' ? "arrow arrow-active" : "arrow arrow-unactive"}></div>
                                <div className={activeTab === 'dates02' ? "tab-image tab-image-02-active" : "tab-image tab-image-02-unactive"}></div>
                            </div>
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className="">
                        <Nav.Link eventKey="dates03">
                            <div className={activeTab === 'dates03' ? "dates-nav-link-item dates-nav-link-item-active" : "dates-nav-link-item"}>
                                <div className={activeTab === 'dates03' ? "number number-active" : "number"}>
                                    <div>03</div>
                                    <div>этап</div>
                                </div>
                                <div className="title">
                                    {"Заключительный \nэтап"}
                                </div>
                                <div className={activeTab === 'dates03' ? "period period-active" : "period"}>
                                    с 19 по 23 октября
                                </div>
                                <div className={activeTab === 'dates03' ? "arrow arrow-active" : "arrow arrow-unactive"}></div>
                                <div className={activeTab === 'dates03' ? "tab-image tab-image-03-active" : "tab-image tab-image-03-unactive"}></div>
                            </div>
                        </Nav.Link>
                    </Nav.Item>

                </Nav>
            </div>
        </div >
    );
}

export default DatesBlock;